import {useDownMd} from "hooks/useLayout";
import {ModalWithHeader} from "../Modal";
import Drawer from "../Drawer";
import {WalletPanelProps} from "../../types";

export default function ModalDrawer({
                                        title,
                                        drawerTitleVisible=true,
                                        ...props}:WalletPanelProps){

    const isDownMd = useDownMd()
    if(isDownMd){
        return <ModalWithHeader {...props} title={title}/>
    }
    return <Drawer {...props} title={drawerTitleVisible ? title : null}/>
}